export const tripsActiveHeader = [
	{
		settings: true,
		text: "Trip id",
		value: "trip_id",
		valueFilter: 'filter_trip_id',
		func: false,
		model: { value: 'list' },
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Broker load",
		value: "broker_number",
		valueFilter: 'filter_broker_number',
		func: false,
		model: { value: 'list' },
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		valueFilter: 'filter_gross',
		func: false,
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Mileage",
		value: "mileage",
		valueFilter: "filter_mileage",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "PU date",
		value: "pick_up_datetime",
		valueFilter: "filter_pick_up_datetime",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'date' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Del-ry date",
		value: "delivery_datetime",
		valueFilter: 'filter_delivery_datetime',
		func: false,
		model: { value: 'list' },
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Route",
		value: "routs",
		valueFilter: "filter_routs",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Payment type",
		value: "payment_type",
		valueFilter: "filter_payment_type",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Payment amount",
		value: "payment_amount",
		valueFilter: "filter_payment_amount",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Payment value",
		value: "payment_value",
		valueFilter: "filter_payment_value",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		footer: "sum",
		dollar: true
	},
	{
		isRemoveAll: true,
		buttons: [
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				textAll: 'Delete all',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		],
	}
];

export const tripsHeader = [
	{
		settings: true,
		text: "Trip id",
		value: "trip_id",
		valueFilter: 'filter_trip_id',
		func: false,
		model: { value: 'list' },
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Broker load",
		value: "broker_number",
		valueFilter: 'filter_broker_number',
		func: false,
		model: { value: 'list' },
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		valueFilter: 'filter_gross',
		func: false,
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Mileage",
		value: "mileage",
		valueFilter: "filter_mileage",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Route",
		value: "routs",
		valueFilter: "filter_routs",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "PU date",
		value: "pick_up_datetime",
		valueFilter: "filter_pick_up_datetime",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'date' },
		left: false,
		dense: true,
	},
	{
		settings: true,
		text: "Del-ry date",
		value: "delivery_datetime",
		valueFilter: 'filter_delivery_datetime',
		func: false,
		model: { value: 'list' },
		sortable: true,
		footer: "count",
	},
	{
		isAddAll: true,
		buttons: [
			{
				perm: true,
				value: 'plus',
				text: 'Add',
				textAll: 'Add all',
				icon: { value: 'plus', w: 16, h: 16 },
			},
		],
	}
];

export const schedulePaymentsTableActiveHeader = [
	{
		settings: true,
		text: "Category",
		value: "category",
		valueFilter: 'filter_category',
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Payment type",
		value: "payment_type",
		valueFilter: 'filter_payment_type',
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		valueFilter: 'filter_amount',
		func: false,
		model: { value: 'number' },
		sortable: true
	},
	{
		settings: true,
		text: "Charge from",
		value: "charge_from",
		valueFilter: 'filter_charge_from',
		func: false,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Charge every",
		value: "charge_every",
		valueFilter: 'filter_charge_every',
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Сharge amount",
		value: "charge_amount",
		valueFilter: 'filter_charge_amount',
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Number of payments",
		value: "number_payments",
		valueFilter: 'filter_number_payments',
		func: false,
		model: { value: 'number' },
		sortable: true
	},
	{
		settings: true,
		text: "Description",
		value: "description",
		valueFilter: 'filter_description',
		func: false,
		model: { value: 'note' },
		sortable: true
	}
];
export const schedulePaymentsTableHeader = [
	{
		settings: true,
		text: "Category",
		value: "category",
		valueFilter: 'filter_category',
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Payment type",
		value: "payment_type",
		valueFilter: 'filter_payment_type',
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		valueFilter: 'filter_amount',
		func: false,
		model: { value: 'number' },
		sortable: true
	},
	{
		settings: true,
		text: "Charge from",
		value: "charge_from",
		valueFilter: 'filter_charge_from',
		func: false,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Charge every",
		value: "charge_every",
		valueFilter: 'filter_charge_every',
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Сharge amount",
		value: "charge_amount",
		valueFilter: 'filter_charge_amount',
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Number of payments",
		value: "number_payments",
		valueFilter: 'filter_number_payments',
		func: false,
		model: { value: 'number' },
		sortable: true
	},
	{
		settings: true,
		text: "Description",
		value: "description",
		valueFilter: 'filter_description',
		func: false,
		model: { value: 'note' },
		sortable: true
	}
];
export const fuelTableActiveHeader = [
	{
		settings: true,
		text: "Fueling date",
		value: "fuel_date",
		valueFilter: 'filter_fuel_date',
		func: false,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Truck #",
		value: "truck_number",
		valueFilter: "filter_truck_number",
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Location",
		value: "location",
		valueFilter: "filter_truck",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Gallons",
		value: "galons",
		valueFilter: "filter_galons",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'number' },
		left: false,
		dense: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		valueFilter: "filter_amount",
		func: false,
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
		footer: "count"
	},
	{
		isRemoveAll: true,
		buttons: [
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				textAll: 'Delete all',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		],
	}
];
export const fuelTableHeader = [
	{
		settings: true,
		text: "Fueling date",
		value: "fuel_date",
		valueFilter: 'filter_fuel_date',
		func: false,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Truck #",
		value: "truck_number",
		valueFilter: "filter_truck_number",
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Location",
		value: "location",
		valueFilter: "filter_truck",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Gallons",
		value: "galons",
		valueFilter: "filter_galons",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'number' },
		left: false,
		dense: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		valueFilter: "filter_amount",
		func: false,
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
		footer: "count"
	},
	{
		isAddAll: true,
		buttons: [
			{
				perm: true,
				value: 'plus',
				text: 'Add',
				textAll: 'Add all',
				icon: { value: 'plus', w: 16, h: 16 },
			},
		],
	}
];

export const additionalPaymentsActiveHeader = [
	{
		settings: true,
		text: "Payment id",
		value: "id",
		valueFilter: "filter_id",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Description",
		value: "description",
		valueFilter: 'filter_description',
		model: { value: 'note' },
		func: false,
		sortable: true,
		align: 'center'
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		valueFilter: "filter_amount",
		func: false,
		model: { value: 'number' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Created date",
		value: "create_at",
		valueFilter: 'filter_create_at',
		func: false,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Created by",
		value: "created_by",
		valueFilter: 'filter_created_by',
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Category",
		value: "category",
		valueFilter: "filter_category",
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		isRemoveAll: true,
		buttons: [
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				textAll: 'Delete all',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		],
	}
];
export const additionalPaymentsHeader = [
	{
		settings: true,
		text: "Payment id",
		value: "id",
		valueFilter: "filter_id",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Description",
		value: 'description',
		valueFilter: "filter_description",
		model: { value: 'note' },
		func: false,
		sortable: true,
		align: 'center'
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		valueFilter: "filter_amount",
		func: false,
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
		footer: "sumDifference",
		dollar: true
	},
	{
		settings: true,
		text: "Created date",
		value: "create_at",
		valueFilter: 'filter_create_at',
		func: false,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Created by",
		value: "created_by",
		valueFilter: 'filter_created_by',
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Category",
		value: "category",
		valueFilter: "filter_category",
		func: false,
		model: { value: 'list' },
		sortable: true
	},
	{
		isRemoveAll: false,
		buttons: [
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				textAll: 'Delete all',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		],
	}
];
